import React, { Fragment } from 'react'
import { Route } from 'react-router'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { OrganizationsSearch } from './OrganizationsSearch'
import { ExperiencesBillingContainer } from './ExperiencesBilling'
import { OrganizationCollections } from './OrganizationCollections'

const AppWrapper = ({ children }) => (
  <StandardLayout greyBg>
    {children}
  </StandardLayout>
)

export const routes = (
  <Fragment>
    <Route component={AppWrapper}>
      <Route path='search' component={OrganizationsSearch} />
      <Route path=':organizationId/experiences_billing' component={ExperiencesBillingContainer} />
    </Route>
    <Route path=':clubIdParam/collections' component={OrganizationCollections} />
  </Fragment>
)
